import React, { useEffect, useState } from 'react'
import qs from 'qs'
import { request } from 'meinian-package/src/utils'
import FileTreeData from 'meinian-package/src/common/fileTreeData'

export const InspirationContext = React.createContext(null)
export const useInspirationContext = () => {
  return React.useContext<FileTreeData>(InspirationContext)
}
export const InspirationProvider = ({ children }) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [data, setData] = useState<FileTreeData>(null)

  const fetchData = async () => {
    if (!query.shareUrl) {
      const res = await request.post('/zhikuan/ins/inspiration/list-simple-inspiration-tree', {})
      setData(
        new FileTreeData({
          data: res,
          childrenKey: 'childs',
        })
      )
    } else {
      setData(
        new FileTreeData({
          data: [],
          childrenKey: 'childs',
        })
      )
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  return <InspirationContext.Provider value={data}>{children}</InspirationContext.Provider>
}
